var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.63898 10.5H3.88164V7.125C3.88164 3.19687 7.08477 0 11.0206 0C14.9564 0 18.1595 3.19687 18.1595 7.125V10.5H14.4022V7.125C14.4022 6.22989 14.0459 5.37145 13.4117 4.73851C12.7776 4.10558 11.9174 3.75 11.0206 3.75C10.1237 3.75 9.2636 4.10558 8.62943 4.73851C7.99525 5.37145 7.63898 6.22989 7.63898 7.125V10.5Z",
    fill: "#335C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5411 12.75V21.75C21.5411 22.3467 21.3036 22.919 20.8808 23.341C20.458 23.7629 19.8846 24 19.2867 24H2.7544C2.1565 24 1.58308 23.7629 1.1603 23.341C0.737517 22.919 0.5 22.3467 0.5 21.75L0.5 12.75C0.5 12.1533 0.737517 11.581 1.1603 11.159C1.58308 10.7371 2.1565 10.5 2.7544 10.5H19.2867C19.8846 10.5 20.458 10.7371 20.8808 11.159C21.3036 11.581 21.5411 12.1533 21.5411 12.75V12.75Z",
    fill: "#335C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpEmail);
export default __webpack_public_path__ + "static/media/SignUpEmail.a4d630554f622299b56875208ecec0aa.svg";
export { ForwardRef as ReactComponent };